export const clearableStore = {
  mutations: {
    CLEAR_STORE_DATA(state) {
      state.list = null;
      state.isInitialLoadPending = true;
      state.isLoading = false;
    }
  }
};